import { Component, OnInit, Input } from '@angular/core';
import { Subscription, Observable } from 'rxjs';

@Component({
  selector: 'busy-spinner',
  templateUrl: './busy-spinner.component.html',
  styleUrls: ['./busy-spinner.component.scss']
})
export class BusySpinnerComponent implements OnInit {

  constructor() { }

  private subscription: Subscription;

  @Input() observable: Observable<any>;
  state = {
    started: false,
    loading: false,
    response: null,
    error: false,
    fade: false
  };

  ngOnInit() {
  }

  ngOnChanges() {
    this.rebind();
  }

  private rebind(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
    if (this.observable) {
      this.state.started = true;
      this.state.loading = true;
      this.subscription = this.observable.share().subscribe(value => {
        setTimeout(() => {
          this.state.fade = true;
        }, 100);
        this.state.response = value;
        this.state.fade = false;
        this.state.error = false;
        this.state.loading = false;
      }, error => {
        this.state.error = true;
        this.state.response = error;
        this.state.fade = false;
        this.state.loading = false;
      });
    }
  }

  showError() {
    var error = this.state.response.error.exceptionMessage;
    alert(`Operation failed. ${error}`);
    //$scope.$emit("showError", $scope.state.response);
  }

  isString(state) {
    return state && (typeof state.response === 'string');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/busy-spinner/busy-spinner.component.ts